"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.onDateFilter = exports.DateFilter = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _ykbUtils = require("ykb-utils");
var _DatePicker = _interopRequireDefault(require("../../DatePicker"));
var _FilterFooter = _interopRequireDefault(require("./FilterFooter"));
var _StyledFilterDropdown = require("../styled/StyledFilterDropdown");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2.default)(o), (0, _possibleConstructorReturn2.default)(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2.default)(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var DateFilter = exports.DateFilter = /*#__PURE__*/function (_Component) {
  function DateFilter(props) {
    var _this;
    (0, _classCallCheck2.default)(this, DateFilter);
    _this = _callSuper(this, DateFilter, [props]);
    _this.state = {
      startValue: null,
      endValue: null,
      endOpen: false
    };
    _this.disabledStartDate = _this.disabledStartDate.bind(_this);
    _this.disabledEndDate = _this.disabledEndDate.bind(_this);
    _this.onChange = _this.onChange.bind(_this);
    _this.onStartChange = _this.onStartChange.bind(_this);
    _this.onEndChange = _this.onEndChange.bind(_this);
    _this.handleStartOpenChange = _this.handleStartOpenChange.bind(_this);
    _this.handleEndOpenChange = _this.handleEndOpenChange.bind(_this);
    return _this;
  }
  (0, _inherits2.default)(DateFilter, _Component);
  return (0, _createClass2.default)(DateFilter, [{
    key: "disabledStartDate",
    value: function disabledStartDate(startValue) {
      var endValue = this.state.endValue;
      if (!startValue || !endValue) {
        return false;
      }
      return startValue.valueOf() > endValue.valueOf();
    }
  }, {
    key: "disabledEndDate",
    value: function disabledEndDate(endValue) {
      var startValue = this.state.startValue;
      if (!endValue || !startValue) {
        return false;
      }
      return endValue.valueOf() <= startValue.valueOf();
    }
  }, {
    key: "onChange",
    value: function onChange(field, value) {
      this.setState((0, _defineProperty2.default)({}, field, value));
    }
  }, {
    key: "onStartChange",
    value: function onStartChange(value) {
      var format = this.props.format;
      if (value && value.set && !format.includes('mm')) {
        value.set({
          hour: 0,
          minute: 0,
          second: 0,
          millisecond: 0
        });
      }
      this.onChange('startValue', value);
    }
  }, {
    key: "onEndChange",
    value: function onEndChange(value) {
      var format = this.props.format;
      if (value && value.set && !format.includes('mm')) {
        value.set({
          hour: 23,
          minute: 59,
          second: 59,
          millisecond: 999
        });
      }
      this.onChange('endValue', value);
    }
  }, {
    key: "handleStartOpenChange",
    value: function handleStartOpenChange(open) {
      if (!open) {
        this.setState({
          endOpen: true
        });
      }
    }
  }, {
    key: "handleEndOpenChange",
    value: function handleEndOpenChange(open) {
      this.setState({
        endOpen: open
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        setSelectedKeys = _this$props.setSelectedKeys,
        _confirm = _this$props.confirm,
        _clearFilters = _this$props.clearFilters,
        locale = _this$props.locale,
        format = _this$props.format;
      var _this$state = this.state,
        startValue = _this$state.startValue,
        endValue = _this$state.endValue,
        endOpen = _this$state.endOpen;
      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_StyledFilterDropdown.StyledFilterContentContainer, null, /*#__PURE__*/_react.default.createElement("p", null, "Ba\u015Flang\u0131\xE7"), /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
        disabledDate: this.disabledStartDate
        // format has mm means we aslo dealing with time
        ,
        showTime: format.includes('mm'),
        format: format,
        value: startValue,
        placeholder: this.props.startPlaceHolder,
        onChange: this.onStartChange,
        onOpenChange: this.handleStartOpenChange,
        size: "small"
      }), /*#__PURE__*/_react.default.createElement("p", null, "Biti\u015F"), /*#__PURE__*/_react.default.createElement(_DatePicker.default, {
        disabledDate: this.disabledEndDate,
        showTime: format.includes('mm'),
        format: format,
        value: endValue,
        placeholder: this.props.endPlaceHolder,
        onChange: this.onEndChange,
        open: endOpen,
        onOpenChange: this.handleEndOpenChange,
        size: "small"
      }), /*#__PURE__*/_react.default.createElement("p", null, " ")), /*#__PURE__*/_react.default.createElement(_FilterFooter.default, {
        locale: locale,
        confirm: function confirm() {
          setSelectedKeys([{
            startDate: _this2.state.startValue,
            endDate: _this2.state.endValue
          }]);
          setTimeout(function () {
            _confirm();
          }, 0);
        },
        clearFilters: function clearFilters() {
          _this2.setState({
            startValue: null,
            endValue: null,
            endOpen: false
          }, function () {
            setSelectedKeys([]);
            setTimeout(function () {
              _clearFilters();
            }, 0);
          });
        }
      }));
    }
  }]);
}(_react.Component);
/**
 * filters by date provided by date filter
 * @param {object} column => { dataIndex, type, format }
 * @param {object|string} value
 * @param {object} record
 */
(0, _defineProperty2.default)(DateFilter, "defaultProps", {
  dropdownPrefixCls: 'ykb-dropdown'
});
var onDateFilter = exports.onDateFilter = function onDateFilter(_ref, value, record) {
  var dataIndex = _ref.dataIndex,
    type = _ref.type,
    format = _ref.format;
  if (!value) return false;
  var date = record[dataIndex];
  if (!date) return false;

  // is js Date
  if (typeof date.getMonth === 'function') {} else if (!date._isAMomentObject) {
    if (typeof date === 'number') {
      date = new Date(Math.floor(date * 1000));
    } else if (date.endsWith('Z')) {
      date = new Date(date);
    } else {
      date = _ykbUtils.dateParser.parseMomentByColumnType({
        type: type,
        format: format
      }, date);
    }
  }

  // this means we are deailing with first date
  if (value.startDate && value.endDate) {
    return value.startDate.toDate() <= date && value.endDate.toDate() >= date;
  } else if (value.startDate) {
    return value.startDate.toDate() <= date;
  } else if (value.endDate) {
    return value.endDate.toDate() >= date;
  }
  return false;
};